import {useState} from '@wordpress/element';
import {BaseControl, TextControl} from '@wordpress/components';

export default function InputOption({attributeName, label, help, attributes, setAttributes, onChange}) {
	const [value, setValue] = useState(attributes[attributeName]);

	return (
		<BaseControl>
			<TextControl
				label={label}
				value={value}
				onChange={nextValue => {

					let _attributes = [];

					_attributes[attributeName] = nextValue;

					setAttributes(_attributes);
					setValue((nextValue));

					onChange && onChange(nextValue)
				}}
			/>
		</BaseControl>
	);
}
